import { render, staticRenderFns } from "./TarefasView.vue?vue&type=template&id=706f1877&"
import script from "./TarefasView.vue?vue&type=script&lang=ts&"
export * from "./TarefasView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports